import DropdownField from '../../../../../../../../elements/DropdownField'
import { default as BedroomsFields } from '../../../../../../../../custom/Bedrooms'
import IconGuest from '/public/icons/icon-guest.svg'
import styles from './styles.module.scss'
import { useSearchContext } from '../../../../../../../../../providers/SearchContext'
import { useEffect, useState } from 'react'

const Guests = ({ width, property, label, ...defaultProps }) => {
  const { setGuests, guests } = useSearchContext()
  const [close, setClose] = useState(false)

  let total = 0

  property?.bedroom_option &&
    property?.bedroom_option?.map((item) => {
      const roomNumber = item.room_title?.split(' ')
      if (roomNumber && Number(roomNumber[0]) > total) {
        total = Number(roomNumber[0])
      }
    })

  useEffect(() => {
    setGuests(null)
  }, [])

  useEffect(() => {
    setClose(true)

    setTimeout(() => setClose(false), 10)
  }, [guests])

  return (
    <DropdownField
      isActive={guests}
      prependIcon={<IconGuest width={22} height={22} />}
      name="guests"
      disabled={!property.is_active}
      triggerClose={close}
      value={guests ? `${label}: ${guests}` : label}
      {...defaultProps}
    >
      <div style={{ width: width }} className={styles.radios}>
        <BedroomsFields
          items={total * 2}
          bedroom
          name="guests"
          value={guests}
          setValue={setGuests}
        />
      </div>
    </DropdownField>
  )
}

export default Guests
